import { Icon } from './Icon';

/** Big number pad for quantities (PRD "Tap, don't type"). Value is a digit string. */
export function NumberPad({
  value,
  onChange,
  maxDigits = 5,
  quick,
  deleteLabel = 'Delete',
}: {
  value: string;
  onChange: (v: string) => void;
  maxDigits?: number;
  quick?: number[];
  deleteLabel?: string;
}) {
  const press = (d: string) => {
    const next = (value + d).replace(/^0+/, '');
    if (next.length <= maxDigits) onChange(next);
  };
  const add = (n: number) => {
    const next = String((Number(value) || 0) + n);
    if (next.length <= maxDigits) onChange(next);
  };
  return (
    <div className="form">
      {quick && (
        <div className="numpad__quick">
          {quick.map((q) => (
            <button key={q} type="button" onClick={() => add(q)}>
              +{q}
            </button>
          ))}
        </div>
      )}
      <div className="numpad">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '00', '0'].map((d) => (
          <button key={d} type="button" onClick={() => press(d)}>
            {d}
          </button>
        ))}
        <button type="button" onClick={() => onChange(value.slice(0, -1))} aria-label={deleteLabel}>
          <Icon name="del" size={22} />
        </button>
      </div>
    </div>
  );
}

export function NumberValue({ value, suffix }: { value: string; suffix: string }) {
  const n = Number(value) || 0;
  return (
    <div className="np-value" aria-live="polite">
      <b>{n.toLocaleString('en-IN')}</b>
      <span>{suffix}</span>
    </div>
  );
}

export function PinDots({ length, filled, error }: { length: number; filled: number; error?: boolean }) {
  return (
    <div className={`pin-dots${error ? ' shake' : ''}`} aria-hidden="true">
      {Array.from({ length }, (_, i) => (
        <span key={i} className={i < filled ? 'on' : ''} />
      ))}
    </div>
  );
}

export function PinPad({
  onDigit,
  onDelete,
  left,
  deleteLabel = 'Delete',
  disabled,
}: {
  onDigit: (d: string) => void;
  onDelete: () => void;
  left?: React.ReactNode;
  deleteLabel?: string;
  disabled?: boolean;
}) {
  return (
    <div className="pinpad">
      {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
        <button key={d} type="button" onClick={() => onDigit(d)} disabled={disabled}>
          {d}
        </button>
      ))}
      {left ?? <span />}
      <button type="button" onClick={() => onDigit('0')} disabled={disabled}>
        0
      </button>
      <button type="button" className="ghost" onClick={onDelete} aria-label={deleteLabel} disabled={disabled}>
        <Icon name="del" size={24} />
      </button>
    </div>
  );
}
